import React from 'react'
import '../home/Home.css';
import card2 from '../images/card2.jpg'; // Import images
import offer from '../images/offer.png';
import offer2 from '../images/offer2.png';
import myntra from '../images/myntra.png';
import ethnic from '../images/ethnic.jpg';
import casual from '../images/casual.jpg';
import active from '../images/active.jpg';
import womenActive from '../images/women_active.jpg';
import western from '../images/western.jpg';
import sports from '../images/sports.jpg';
import lounge from '../images/lounge.jpg';
import inner from '../images/inner.jpg';
import shorts from '../images/shorts.jpg';import watch from '../images/watch.jpg';
import groom from '../images/groom.jpg';
import beauty from '../images/BEAUTY.jpg';
import appLink from '../images/app_link.png';

import { useSelector } from 'react-redux';

export default function Home() {
  const theme = useSelector((state)=>state.theme);
  //creating a style object for applying inline styling to "category_cards_item"
  const style = 
    theme=="light"?{ backgroundImage: `url(${card2})` }:{backgroundColor:"#8C8C8C"};
  return (
    <div className="App" style={theme === "light"?{backgroundColor:"white"}:{backgroundColor:"#44444C"}}>
      {/* <header style={{ position: 'sticky', top: '0' }}>
        <nav>
          <div className="nav_bar">
            <div className="nav_bar_items">
              <a href="">
                <img src={myntra} alt="myntra logo" style={{ height: '50px' }} />
              </a>
            </div>
            <div className="nav_bar_items"><Link to="/productListing">MEN</Link></div>
            <div className="nav_bar_items"><a href="">WOMEN</a></div>
            <div className="nav_bar_items"><a href="">KIDS</a></div>
            <div className="nav_bar_items"><a href="">HOME & LIVING</a></div>
            <div className="nav_bar_items"><a href="">BEAUTY</a></div>
            <div className="nav_bar_items">
              <a href="">STUDIO<sup style={{ color: 'red' }}>NEW</sup></a>
            </div>
            <div className="nav_bar_items">
              <form>
                <input type="search" placeholder="Search for Products, Brands and More" size="50" />
                <button type="submit"><i className="fa-solid fa-magnifying-glass"></i></button>
              </form>
            </div>
            <div className="nav_bar_items"><a href="">PROFILE</a></div>
            <div className="nav_bar_items"><a href="">BAG</a></div>
            <div className="nav_bar_items"><a href="">WISHLIST</a></div>
          </div>
        </nav>
      </header> */}

      <header>
        <div className="offer_banner" >
          <a href=""><img src={ theme === "light" ? offer:offer2} alt="offer banner" style={{ width: '100%' }} /></a>
        </div>
      </header>

      <main>
        <div style={{ display: 'flex', justifyContent: 'center', fontFamily: "'Cambria', 'Cochin', 'Georgia', 'Times', 'Times New Roman', serif", color: 'black' }}>
          <h1 style={theme==="light"?{color:"black"}:{color:"#D6D6D6"}}>Shop By Category</h1>
        </div>
        <div className="category_cards">
          <div className="category_cards_item" style={style}>
            <img src={ethnic} alt="Ethnic Wear" />
            <h3>Ethnic Wear</h3>
            <h2>50-80% OFF</h2>
            <h3>Shop Now</h3>
          </div>
          <div className="category_cards_item" style={style}>
            <img src={casual} alt="WFH Casual Wear" />
            <h3>WFH Casual Wear</h3>
            <h2>40-80% OFF</h2>
            <h3>Shop Now</h3>
          </div>
          <div className="category_cards_item" style={style}>
            <img src={active} alt="Men's Wear" />
            <h3>Men's Wear</h3>
            <h2>30-70% OFF</h2>
            <h3>Shop Now</h3>
          </div>
          <div className="category_cards_item" style={style}>
            <img src={womenActive} alt="Women's Wear" />
            <h3>Women's Wear</h3>
            <h2>30-70% OFF</h2>
            <h3>Shop Now</h3>
          </div>
          <div className="category_cards_item" style={style}>
            <img src={western} alt="Western Wear" />
            <h3>Western Wear</h3>
            <h2>40-80% OFF</h2>
            <h3>Shop Now</h3>
          </div>
          <div className="category_cards_item" style={style}>
            <img src={sports} alt="Sports Wear" />
            <h3>Sports Wear</h3>
            <h2>30-80% OFF</h2>
            <h3>Shop Now</h3>
          </div>
        </div>

        <div className="category_cards">
          <div className="category_cards_item" style={style}>
            <img src={lounge} alt="Lounge Wear" />
            <h3>Lounge Wear</h3>
            <h2>30-60% OFF</h2>
            <h3>Shop Now</h3>
          </div>
          <div className="category_cards_item" style={style}>
            <img src={inner} alt="Inner Wear" />
            <h3>Inner Wear</h3>
            <h2>UP TO 70% OFF</h2>
            <h3>Shop Now</h3>
          </div>
          <div className="category_cards_item" style={style}>
            <img src={shorts} alt="Shorts" />
            <h3>Shorts</h3>
            <h2>UP TO 70% OFF</h2>
            <h3>Shop Now</h3>
          </div>
          <div className="category_cards_item" style={style}>
            <img src={watch} alt="Watch" />
            <h3>Watch</h3>
            <h2>UP TO 80% OFF</h2>
            <h3>Shop Now</h3>
          </div>
          <div className="category_cards_item" style={style}>
            <img src={groom} alt="Groom Wear" />
            <h3>Groom Wear</h3>
            <h2>UP TO 60% OFF</h2>
            <h3>Shop Now</h3>
          </div>
          <div className="category_cards_item" style={style}>
            <img src={beauty} alt="Beauty" />
            <h3>Beauty</h3>
            <h2>UP TO 70% OFF</h2>
            <h3>Shop Now</h3>
          </div>
        </div>
      </main>

      <div>
        <a href=""><img src={appLink} alt="" style={{ width: '100%' }} /></a>
      </div>
    </div>
  )
}
